// Wording of the end-of-year staff appraisal (Puffin End of the year Appraisal form)

export const RATINGS = [
  [5, 'Outstanding', 'Far beyond what the role requires'],
  [4, 'Exceeds expectations', 'Consistently above the standard expected'],
  [3, 'Meets expectations', 'Fully effective. This is the standard rating'],
  [2, 'Partly meets expectations', 'Some goals or standards not met; needs a plan'],
  [1, 'Does not meet expectations', 'Significant shortfall against core requirements'],
];

export const GUIDANCE = [
  'Answer every question. Short answers are fine (two or three sentences each).',
  'Give real examples. One specific example is worth more than three general statements.',
  'Write honestly about what did not go well. If a question does not apply to your role, write "Not applicable".',
];

export const PARTS = {
  personal: {
    title: 'Part 1. Personal goals',
    note: 'The goals agreed for you at the start of the year.',
    rows: 5,
    columns: [['goal', 'My personal goal'], ['achieved', 'Did I achieve it?', 'yesno'], ['rating', 'Rating', 'rating'], ['evidence', 'Evidence: what I actually delivered']],
    questionsKey: 'personal_q',
    questions: [
      ['pleased', 'Which personal goal are you most pleased with, and why?'],
      ['not_achieved', 'Which goal did you not achieve, and what was the reason?'],
      ['next_goal', 'What personal goal would you set for yourself next year?'],
    ],
  },
  department: {
    title: 'Part 2. Departmental goals',
    note: 'How your department performed, and the part you played in it.',
    rows: 5,
    columns: [['goal', "Our department's goal"], ['how', 'How did we do?'], ['contribution', 'My contribution to it']],
    questionsKey: 'department_q',
    questions: [
      ['did_well', 'What did your department or team do well this year?'],
      ['held_back', 'What held your department or team back, and what would fix it?'],
      ['focus', 'What should the department or team focus on next year?'],
      ['need', 'What do you need from the department or team to do your job better?'],
    ],
  },
  company: {
    title: 'Part 3. Contribution to Puffin (company goals)',
    note: 'The company-wide goals and how your work contributes to them. Rate your contribution to each, then comment.',
    rows: 5,
    columns: [['goal', 'Puffin goal'], ['rating', 'Rate my contribution', 'rating'], ['did', 'What I did towards it']],
    questionsKey: 'company_q',
    questions: [
      ['supports_most', 'Which Puffin goal does your work support most directly, and how?'],
      ['beyond', 'What did you do this year that helped the company beyond your own department?'],
      ['differently', 'What is one thing the company should do differently next year, and what could you do to help?'],
    ],
  },
};

export const DEVELOPMENT = [
  ['strengths', 'What are your two strongest skills, and where did you use them this year?'],
  ['develop', 'What skill or knowledge do you most need to develop next year, and why?'],
  ['support', 'What training, support or experience would help you most?'],
  ['twelve_months', 'What would you like to be doing in Puffin twelve months from now?'],
];

export const SUMMARY_QUESTION =
  'In three or four sentences, sum up your year: what you are proudest of, what you would do differently, and what you want from next year.';

export const NEXT_GOAL_COLUMNS = [['goal', 'Goal'], ['measure', 'How I will measure it'], ['support', 'Support I need']];

// Part 5, anonymous
export const MANAGERS = [
  ['ta', 'T.A. (Mr. Abduljabbar)', 'Focus on the technical and general support you receive.', 'T.A.'],
  ['pm', "P.M. (Mr. Al'ameen Bashir)", 'Focus on the technical and general support you received.', 'P.M.'],
  ['hr', 'HR (Mr. Rotimi)', 'Focus on recruitment, technical and general support you received.', 'HR'],
  ['gmd', "G.M.D. (Al'Amin Abba Kabir)", 'Focus on the overall direction, culture and leadership of the company.', 'G.M.D.'],
];

export const STATEMENTS = [
  ['s1', 'Communicates clearly and in good time'],
  ['s2', 'Sets clear expectations; safe to raise a problem'],
  ['s3', 'Competent, fair and consistent'],
  ['s4', 'Helps rather than hinders my work'],
];

export const COMPANY_QUESTIONS = [
  ['together', 'How well do you think the management roles above work together?'],
  ['decisions', 'Is it clear who decides what, and are decisions made quickly enough?'],
  ['recognised', 'Do you feel your work is recognised and valued? What would you change?'],
  ['stay', 'What would make you want to stay with this company for the next three years?'],
  ['suggestion', 'General recommendation or suggestion to Puffin'],
];

export const COLLEAGUES_QUESTION =
  'List 3 names of your best colleagues this year and why. Put them in order of your rating, with 1 being the best and 3 being the third best.';

export const emptyAnswers = () => ({
  personal: Array.from({ length: 5 }, () => ({ goal: '', achieved: '', rating: '', evidence: '' })),
  personal_q: { pleased: '', not_achieved: '', next_goal: '' },
  department: Array.from({ length: 5 }, () => ({ goal: '', how: '', contribution: '' })),
  department_q: { did_well: '', held_back: '', focus: '', need: '' },
  company: Array.from({ length: 5 }, () => ({ goal: '', rating: '', did: '' })),
  company_q: { supports_most: '', beyond: '', differently: '' },
  development: { strengths: '', develop: '', support: '', twelve_months: '' },
  summary: '',
  next_goals: Array.from({ length: 3 }, () => ({ goal: '', measure: '', support: '' })),
});

export const emptyFeedback = () => ({
  managers: Object.fromEntries(MANAGERS.map(([k]) => [k, { ratings: {}, comments: {}, well: '', change: '' }])),
  company: { together: '', decisions: '', recognised: '', stay: '', suggestion: '' },
  colleagues: [{ employee_id: '', reason: '' }, { employee_id: '', reason: '' }, { employee_id: '', reason: '' }],
});
